import { faFlagCheckered, faPlay, faProjectDiagram } from '@fortawesome/free-solid-svg-icons'
import { createSlice } from '@reduxjs/toolkit'

const api = createSlice({
    name: 'api',//Данные для виджетов 
    initialState: {
        menu: [], //Меню
        menuLoaded: false,
        controllers: [],
        mobileMenuShow: false
        // method: []
    },
    reducers: {
        loadMenu(state, action) {
            const list = action.payload.list;
            state.menu = list;
            state.menuLoaded = true;

            var controllers = []
            list.map(item => {
                if (controllers.filter(a => a.ID_Controller === item.ID_Controller).length === 0) {
                    controllers.push(
                        {
                            ID_Controller: item.ID_Controller,
                            Name_Controller: item.Name_Controller,
                            Url_Controller: item.Url_Controller,
                            Order_Controller: item.Order_Controller,
                            Open: false
                        })
                }
            })

            state.controllers = controllers;
        },
        openCloseMenu(state, action) {
            const id_controller = action.payload.id_controller;
            //const val = action.payload.list;

            state.controllers = state.controllers.map(item => {
                if (item.ID_Controller == id_controller) {
                    return { ...item, Open: !item.Open };
                }
                else {
                    return item;
                }
            });
        },
        mobileMenuShow(state, action) {
            const val = action.payload.val;
            state.mobileMenuShow = val;
        },
    }
})

export const { loadMenu, openCloseMenu, mobileMenuShow } = api.actions
export default api.reducer